import { backendFetch } from 'services/backend-auth';
import { mediaGateways, preferredGateway, r2MediaUrl, gatewayLabel, useMediaConfig } from 'services/media';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../helpers/authContext'; 
import { setSteemConfig } from 'config';
import { Alert, Button, FormGroup, Label, Input } from 'reactstrap';
import { backend, add_to_blacklist, create_banner, create_notification, delete_banner, delete_ipfs_content, delete_notification, get_blacklist, get_carousel_items, get_db_notifications, get_ipfs_usage, get_leaderboard, get_quota, is_admin, remove_from_blacklist, update_notification, update_site_settings, get_user_preferences, set_user_preferences, set_posting_preferences, remove_auto_tag, get_muted_users, mute_user, unmute_user, promote_user_to_plus, demote_user_from_plus } from 'services/db-service';
import AdvancedSettings from 'components/AdvancedSettings';
import ImageUploader from 'components/ImageUploader';
import { VerifiedIcon } from 'components/VerifiedIcon';
import { useForm } from 'react-hook-form';
import { useToast } from 'components/ui/use-toast';
import { getTimeAgo } from 'services/posts-service'; 
// import { useSelector } from 'react-redux';
// import { RootState } from 'app/store/rootReducer';
import { getUser } from 'services/user-service';
import { accountUpdateWithWif } from 'helpers/steem';
import LoginModal from './userModals/LoginModal';
import useModal from 'helpers/useModal';
import AppModal from 'components/Modal';
import ContentCreatePostModal from 'features/content/contentModals/ContentCreatePostModal';
import { accountUpdateKeychain, addPostingAuthorityKeychain, removePostingAuthorityKeychain } from 'helpers/keychain';
import { isLoggedWithKeychain } from 'services/dsteem-service';
import { SCHEDULE_ACCOUNT, isAuthorized, authorizeAccount, fetchScheduleAccount, revokeAccount } from 'services/authority-service';

const DAYS_FOR_RESET = parseInt(process.env.DAYS_FOR_RESET) || 30;
const MINIMUN_SP_FOR_PLUS = parseInt(process.env.MINIMUN_SP_FOR_PLUS) || 1000;

/* ── Helpers ────────────────────────────────────────────────────────── */
function getWeekStart(offset = 0): string {
  const now = new Date();
  const dayOfWeek = now.getUTCDay();
  const daysSinceMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() - daysSinceMonday + offset * 7
  ));
  return monday.toISOString().slice(0, 10);
}

function formatWeekLabel(start: string): string {
  const s = new Date(start + 'T00:00:00Z');
  const e = new Date(s);
  e.setUTCDate(e.getUTCDate() + 6);
  const fmt = (d: Date) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
  return `${fmt(s)} – ${fmt(e)}, ${e.getUTCFullYear()}`;
}

const PREF_TOPICS = ['science', 'life', 'cooking', 'games', 'art', 'technology', 'entertainment', 'travel'];
const PREF_LANGS = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Spanish' },
  { code: 'bn', label: 'Bengali' },
  { code: 'zh', label: 'Chinese' },
  { code: 'it', label: 'Italian' }
];

const UserSettings = () => {
  useMediaConfig();
  const auth = useAuth(); 
  const { register, watch, setValue } = useForm<FormData>(); 
  if (!auth) {
    throw new Error("out of context, please contact the administrator.");
  } 
  const { user,autologin, rpc_node, updateRPCNode, app_settings, updateAppSettings } = auth;
  const username=user;
  // const isAdmin = ADMIN_LIST.includes(user);
  const [adminNotifications, setAdminNotifications] = useState<any[]>([]);
  const [carouselItems, setCarouselItems] = useState<any[]>([]);
  const [isAdmin, setIsAdmin] = useState<any>(false);
  const [requiredActive, setRequiredActive] = useState<any>(true);
  const [Quota, setQuota] = useState<any>(0);
  const [ipfsAccount, setIpfsAccount] = useState<any>({ files: [] });
  const [ipfsPersonal, setIpfsPersonal] = useState<any>({});
  const [userData, setUserData] = useState<any>();
  const { isOpenLoginModal, toggleLoginModal  } = useModal();
  const [planType, setPlanType] = useState<any>("free");
  const { tab } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>(tab || 'app');
 
  const [reportWeekOffset, setReportWeekOffset] = useState(0);
  const [reportMarkdown, setReportMarkdown] = useState('');
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const [rpcUrl, setRpcUrl] = useState<string>(rpc_node || 'https://api.steemit.com');
  const [gateway, setGateway] = useState<string>(preferredGateway(app_settings?.gateway));
  const [autoplay, setAutoplay] = useState<boolean>(app_settings.autoplay || false);
  const [newNotification, setNewNotification] = useState({ url: '', msg: '' });
  const [newBanner, setNewBanner] = useState({ src: '', altText: '', caption: '', link: '' });
  const [newProfile, setNewProfile] = useState({ profile_image: '', cover_image: '', about: '', location: '', name:'', website:'' });
  const { toast } = useToast();
  // const {
  //     userData, 
  //     // isLoading,
  //     // error
  // } = useSelector((state: RootState) => state.userData);
  // ADMIN VARS
  // const [files, setFiles] = useState([]);
  const [groupedUsers, setGroupedUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [blacklist, setBlacklist] = useState<any[]>([]);
  const [newBlacklistEntry, setNewBlacklistEntry] = useState({ username: '', reason: '' });
  const [userPreferences, setUserPreferences] = useState({ lan: 'en', preferences: [] as string[], auto_preferences: {} as Record<string, number> });
  const [customTag, setCustomTag] = useState('');
  const [mutedUsers, setMutedUsers] = useState<string[]>([]);
  const [newMuteUser, setNewMuteUser] = useState('');
  const [postingOptions, setPostingOptions] = useState({
    rewards: '1',
    beneficiaries: [{ account: '', weight: '' }]
  });
  const [postingOrientation, setPostingOrientation] = useState<'clip' | 'video'>('clip');
  const [postingSupportSpeak, setPostingSupportSpeak] = useState(true);

  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({
    storage: false,
    preferences: false,
    posting_prefs: false,
    general: false,
    profile: false,
    adsense: false,
    ipfs: false,
    notifications: false,
    blacklist: false,
    carousel: false,
    reports: false,
    mutes: false,
    authority: false
  });

  const toggleSection = (name: string) => {
    setExpandedSections(prev => ({ ...prev, [name]: !prev[name] }));
  };
  
  const [isAuthorizedSteemSeven, setIsAuthorizedSteemSeven] = useState<boolean | null>(null);
  const [authorizing, setAuthorizing] = useState(false);
  const [revokingAuthority, setRevokingAuthority] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [scheduledPosts, setScheduledPosts] = useState<any[]>([]);
  const [postToEdit, setPostToEdit] = useState<any>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [motherAcc, setMotherAcc] = useState<string>(SCHEDULE_ACCOUNT);

  const fetchScheduledPosts = async () => {
    try {
      const res = await backendFetch(`${backend}/api/v1/scheduled_posts/${user}`);
      if (res.ok) {
        const data = await res.json();
        setScheduledPosts(data);
      }
    } catch(e) {
      console.error('Failed to fetch scheduled posts', e);
    }
  };

  const handleCancelScheduledPost = async (id: number) => {
    if (!window.confirm('Are you sure you want to cancel this scheduled post?')) return;
    try {
      const res = await backendFetch(`${backend}/api/v1/scheduled_post/${id}`, { method: 'DELETE' });
      if (res.ok) {
        setScheduledPosts(prev => prev.filter(p => p.id !== id));
        toast({ title: "Success", description: "Post cancelled.", variant: "wild_green" });
      }
    } catch(e) {
      toast({ title: "Error", description: "Could not cancel post.", variant: "rose_red" });
    }
  };

  const handleRevokeSteemSeven = async (activeWif = "") => {
    const res = await revokeAccount(autologin, motherAcc, activeWif);
    if (res.success) {
      setIsAuthorizedSteemSeven(false);
      toast({ title: "Success", description: res.message, variant: "wild_green" });
    } else {
      if (res.message.toString().includes("Missing Active Authority")) {
        setRequiredActive(true);
        setRevokingAuthority(true);
        toggleLoginModal();
      } else {
        toast({ title: "Error", description: res.message, variant: "rose_red" });
      }
    }
  };

  const handleRevokeClick = () => {
    setShowRevokeModal(true);
  };

  const confirmRevoke = async () => {
    setShowRevokeModal(false);
    setAuthorizing(true);
    try {
      if (isLoggedWithKeychain(autologin)) {
        const result: any = await removePostingAuthorityKeychain(user, motherAcc);
        if (result && result.success) {
            setIsAuthorizedSteemSeven(false);
            toast({ title: "Success", description: "Authority revoked successfully.", variant: "wild_green" });
        } else if (result) {
            toast({ title: "Error", description: result.message || "Failed to revoke.", variant: "rose_red" });
        }
      } else {
        setRequiredActive(true);
        setRevokingAuthority(true);
        toggleLoginModal();
      }
    } catch(e) {
      toast({ title: "Error", description: "An error occurred.", variant: "rose_red" });
    }
    setAuthorizing(false);
  };

  const handleAuthorizeClick = async () => {
    setAuthorizing(true);
    try {
      if (isLoggedWithKeychain(autologin)) {
        const result: any = await addPostingAuthorityKeychain(user, motherAcc);
        if (result && result.success) {
            setIsAuthorizedSteemSeven(true);
            toast({ title: "Success", description: "Account authorized successfully.", variant: "wild_green" });
        } else if (result) {
            toast({ title: "Error", description: result.message || "Failed to authorize.", variant: "rose_red" });
        }
      } else {
        toggleLoginModal();
      }
    } catch(e) {
      toast({ title: "Error", description: "An error occurred.", variant: "rose_red" });
    }
    setAuthorizing(false);
  };

  const [currentPagePersonal, setCurrentPagePersonal] = useState(1);
  const itemsPerPagePersonal = 10;
  const GATEWAYS = mediaGateways();
  // paginación admin (si deseas)


  const [currentPageAdminUsers, setCurrentPageAdminUsers] = useState(1);
  const itemsPerPageAdminUsers = 10;

  const [currentPageSelectedUser, setCurrentPageSelectedUser] = useState(1);
  const itemsPerPageSelectedUser = 10;

  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    async function getUserData() {
      let data = await getUser(username);
      setUserData(data);
    }
    getUserData();
  },[]);

  useEffect(() => {
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [tab, activeTab]);

  useEffect(() => { 
    if (userData && userData.posting_json_metadata) {
      try {
          const metadata = JSON.parse(userData.posting_json_metadata); 
          
          const profile = metadata.profile || {}; 
          let it = {
          name: profile.name|| "",
          about: profile.about || ``,
          profile_image: profile.profile_image || profile.avatar || `https://steemitimages.com/u/${username}/avatar`,
          cover_image: profile.cover_image || "",
          location: profile.location || "",
          website: profile.website || ""
          }
          setNewProfile(it);
      } catch (e) {
          setNewProfile({
          name: "",
          about: ``,
          profile_image: "",
          cover_image: "",
          location: "",
          website: ""
          });
      }
    } 
  }, [userData, username]);
  const handleToggleAds = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const enabled = e.target.checked;
    const success = await update_site_settings(user || "", { ads_enabled: String(enabled) });
    if (success) {
      auth.updateSiteSettings({ ads_enabled: String(enabled) });
      toast({
        title: "Settings updated",
        description: `Ads are now ${enabled ? 'enabled' : 'disabled'}.`,
        variant: "wild_green"
      });
    } else {
      toast({
        title: "Error updating settings",
        description: "Could not update AdSense settings.",
        variant: "rose_red"
      });
    }
  };

  const handleCreateNotification = async () => {
    if (!newNotification.url || !newNotification.msg) { 
      toast({
        title: "Failure while creating notification",
        description: `Please fill in both URL and message.`,
        variant:"rose_red"
      }); 
      return;
    }

    try {
      let new_item = { 
        url: newNotification.url,
        msg: newNotification.msg,
        created: new Date().toISOString().slice(0, 19),
        active: true 
      }
      const created = await create_notification(new_item);
      if (created) {
        setAdminNotifications(prev => [...prev, new_item]);
        setNewNotification({ url: '', msg: '' });
      }
      
    } catch (err) {
      toast({
        title: "Error creating notification",
        description: err,
        variant:"rose_red"
      }); 
    }
  };
  const handleCreateBanner = async () => {
    if (!newBanner.src || !newBanner.link) { 
      toast({
        title: "Failure while creating banner",
        description: `Please fill in both src and link.`,
        variant:"rose_red"
      }); 
      return;
    }

    try {
      let new_item = { 
        src: newBanner.src,
        link: newBanner.link,
        altText: newBanner.altText,
        caption: newBanner.caption 
      }
      const created = await create_banner(new_item); 
      if (created) {
        setCarouselItems(prev => [...prev, new_item]);
        setNewBanner({ src: '', link: '', caption: '', altText: '' });
      }
      
    } catch (err) {
      toast({
        title: "Error creating banner",
        description: err,
        variant:"rose_red"
      }); 
    }
  }; 
  const handleToggleStatus = async (notification: any) => {
    try {
      const updated = { ...notification, active: !notification.active };
      await update_notification(notification.id, !notification.active);
      setAdminNotifications(prev =>
        prev.map(n => (n.id === notification.id ? updated : n))
      );
    } catch (err) {
      toast({
        title: "Error updating this item",
        description: err,
        variant:"rose_red"
      }); 
    }
  }; 
  const handleDeleteNotification = async (notificationId: number) => {
    if (!window.confirm("Are you sure you want to delete this notification?")) return;
    try {
      await delete_notification(notificationId);
      setAdminNotifications(prev => prev.filter(n => n.id !== notificationId));
    } catch (err) {
      toast({
        title: "Error deleting notification",
        description: err,
        variant:"rose_red"
      }); 
    }
  };
  const handleUnpinIpfs = async (cid: string) => {
    if (!window.confirm("Delete this video from storage and your upload library? Existing posts may keep its link, and cached or independently hosted copies may remain.")) return;
    try {
      let res = await delete_ipfs_content(cid, user);
      if (res?.success) {
        // do something
        setIpfsPersonal(prev => Array.isArray(prev) ? prev.filter((file: any) => file.cid !== cid) : prev); 
        setIpfsAccount(prev => {
          const updatedFiles = Array.isArray(prev?.files) ? prev.files.filter((file: any) => file.cid !== cid) : [];
          setGroupedUsers(groupByUser(updatedFiles));
          return {
            ...prev,
            files: updatedFiles
          };
        });
        toast({
          title: "File deleted",
          description: `CID: ${cid} was removed successfully.`,
          variant:"wild_green"
        });
      }
      
      // setAdminNotifications(prev => prev.filter(n => n.id !== notificationId));
    } catch (err) {
      toast({
        title: "Error deleting video",
        description: err?.response?.data?.message || err?.message || "Refresh your library and retry deletion.",
        variant:"rose_red"
      }); 
    }
  };

  const handlePromotePlus = async (targetUsername: string) => {
    const quotaStr = window.prompt("Enter storage limit for manual Plus plan (in MB):", "10000");
    if (quotaStr === null) return;
    const quota = parseInt(quotaStr) || 10000;
    try {
      const success = await promote_user_to_plus(user, targetUsername, quota);
      if (success) {
        toast({
          title: "User promoted to Plus",
          description: `User @${targetUsername} has been promoted manually to Plus with ${quota} MB quota.`,
          variant: "wild_green"
        });
        setGroupedUsers(prev => prev.map(u => {
          if (u.user === targetUsername) {
            return {
              ...u,
              plan: "free-plus",
              quota: quota,
              status: "manual",
              files: u.files.map(f => ({ ...f, plan_type: "free-plus", storage_limit_mb: quota, plan_status: "manual" }))
            };
          }
          return u;
        }));
      } else {
        toast({
          title: "Error",
          description: "Failed to promote user to Plus.",
          variant: "rose_red"
        });
      }
    } catch (err) {
      toast({
        title: "Error",
        description: typeof err === 'object' && err !== null && 'message' in err ? String(err.message) : String(err),
        variant: "rose_red"
      });
    }
  };

  const handleDemotePlus = async (targetUsername: string) => {
    if (!window.confirm(`Are you sure you want to remove Manual Plus promotion from @${targetUsername}?`)) return;
    try {
      const success = await demote_user_from_plus(user, targetUsername);
      if (success) {
        toast({
          title: "Manual Plus removed",
          description: `Manual Plus promotion for @${targetUsername} has been removed. Plan is now set to active/free.`,
          variant: "wild_green"
        });
        setGroupedUsers(prev => prev.map(u => {
          if (u.user === targetUsername) {
            return {
              ...u,
              plan: "free",
              quota: 5000,
              status: "active",
              files: u.files.map(f => ({ ...f, plan_type: "free", storage_limit_mb: 5000, plan_status: "active" }))
            };
          }
          return u;
        }));
      } else {
        toast({
          title: "Error",
          description: "Failed to remove manual Plus.",
          variant: "rose_red"
        });
      }
    } catch (err) {
      toast({
        title: "Error",
        description: typeof err === 'object' && err !== null && 'message' in err ? String(err.message) : String(err),
        variant: "rose_red"
      });
    }
  };
  const handleDeleteBanner = async (bannerId: number) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      await delete_banner(bannerId);
      setCarouselItems(prev => prev.filter(n => n.id !== bannerId));
    } catch (err) {
      toast({
        title: "Error deleting banner",
        description: err,
        variant:"rose_red"
      }); 
    }
  };

  const handleFetchBlacklist = async () => {
    if (!isAdmin) return;
    try {
      const data = await get_blacklist(user);
      setBlacklist(data);
    } catch (err: any) {
      // Silence 403 error for non-admin users
      if (err?.response?.status !== 403) {
        console.error("Error fetching blacklist:", err);
      }
    }
  };

  const handleAddBlacklist = async () => {
    if (!newBlacklistEntry.username) return;
    try {
      const success = await add_to_blacklist(user, newBlacklistEntry.username, newBlacklistEntry.reason);
      if (success) {
        toast({ title: "User blacklisted", variant: "wild_green" });
        setNewBlacklistEntry({ username: '', reason: '' });
        handleFetchBlacklist();
      }
    } catch (err) {
    }
  };

  const handleRemoveBlacklist = async (username: string) => {
    try {
      const success = await remove_from_blacklist(user, username);
      if (success) {
        toast({ title: "User removed from blacklist", variant: "wild_green" });
        handleFetchBlacklist();
      }
    } catch (err) {
    }
  };

  const handleAccountUpdate = async (newWif = "") => {
    let keychainLogin = isLoggedWithKeychain(autologin); 
    const voteFn = keychainLogin ? accountUpdateKeychain : accountUpdateWithWif;
    const account = keychainLogin ? user : autologin;
    let res:any = await voteFn(account, newProfile, newWif);
    if (!res.success) {
      if(res.message.toString().includes("Missing Active Authority")){
        setRequiredActive(true);
        toggleLoginModal();
        return;
      }
      
      toast({
        title:"Failed updating account profile.",
        description:res.message,
        variant:"rose_red"
      });
    }else {
      toast({
        title:"Account updated successfully.",
        description:"Your changes may take a few minutes to take effect.",
        variant:"wild_green"
      });
    }
  };

  // Archivos que cuentan según la regla
  const validFiles = Array.isArray(ipfsPersonal)
    ? ipfsPersonal.filter(item => planType.includes("plus") ? Number(item.days_ago) <= DAYS_FOR_RESET:true)
    : [];

  // Archivos que quedarían fuera (ahorro)
  const removedFiles = Array.isArray(ipfsPersonal)
    ? ipfsPersonal.filter(item => Number(item.days_ago) > DAYS_FOR_RESET)
    : [];

  // Total usado actualmente con reglas
  const totalPersonalSize = validFiles.reduce(
    (acc, item) => acc + (parseFloat(item.size) || 0), 
    0
  );

  // Total potencial a ahorrar
  const totalStorageSaved = removedFiles.reduce(
    (acc, item) => acc + (parseFloat(item.size) || 0), 
    0
  ); 
  
  const totalSize = Array.isArray(ipfsAccount.files)
  ? ipfsAccount.files.reduce((acc, item) => acc + Number(item.size || 0), 0)
  : 0;

    // PERSONAL
  const indexOfLastPersonal = currentPagePersonal * itemsPerPagePersonal;
  const indexOfFirstPersonal = indexOfLastPersonal - itemsPerPagePersonal;
  const currentPersonalFiles = Array.isArray(ipfsPersonal)
    ? ipfsPersonal.slice(indexOfFirstPersonal, indexOfLastPersonal)
    : [];


  // USERS (ADMIN)
  const filteredAdminUsers = Array.isArray(groupedUsers)
    ? groupedUsers.filter(u => u.user.toLowerCase().includes(searchQuery.toLowerCase()))
    : [];

  const indexOfLastAdminUsers = currentPageAdminUsers * itemsPerPageAdminUsers;
  const indexOfFirstAdminUsers = indexOfLastAdminUsers - itemsPerPageAdminUsers;
  const currentAdminUsers = filteredAdminUsers.slice(indexOfFirstAdminUsers, indexOfLastAdminUsers);

  // SELECTED USER FILES (ADMIN)
  const selectedUserData = selectedUser ? groupedUsers.find(u => u.user === selectedUser) : null;
  const indexOfLastSelectedUser = currentPageSelectedUser * itemsPerPageSelectedUser;
  const indexOfFirstSelectedUser = indexOfLastSelectedUser - itemsPerPageSelectedUser;
  const currentSelectedUserFiles = selectedUserData && Array.isArray(selectedUserData.files)
    ? selectedUserData.files.slice(indexOfFirstSelectedUser, indexOfLastSelectedUser)
    : [];
  // let userSpaces = groupByUser(ipfsAccount.files);
  useEffect(() => { 
    setCurrentPagePersonal(1);
  }, [ipfsPersonal]);

  useEffect(() => {

    setCurrentPageAdminUsers(1);
  }, [ipfsAccount, searchQuery]);

  useEffect(() => {
    setCurrentPageSelectedUser(1);
  }, [selectedUser]);
  function groupByUser(files) {
    const grouped = {};

    files.forEach(file => {
      if (!grouped[file.by]) {
        grouped[file.by] = {
          user: file.by,
          total_size: 0,
          files: [],
          plan: file.plan_type,
          quota: file.storage_limit_mb || 5000,
          status: file.plan_status || 'active'
        };
      }

      grouped[file.by].files.push(file);
      grouped[file.by].total_size += (file.size) / 1e6;
    });

    return Object.values(grouped).sort((a:any, b:any) => b.total_size - a.total_size);
  }

  const generateLeaderboardReport = async () => {
    setIsGeneratingReport(true);
    try {
      const start = getWeekStart(reportWeekOffset);
      const label = formatWeekLabel(start);
      const data = await get_leaderboard(start);
      const entries = data.entries || [];
      const top50 = entries.sort((a,b) => b.score - a.score).slice(0, 50);

      let md = `### 📊 Speem Weekly Leaderboard Report\n`;
      md += `**Week:** ${label}\n\n`;
      md += `| Rank | User | Score | Views | Videos | Watched |\n`;
      md += `| :--- | :--- | :--- | :--- | :--- | :--- |\n`;

      top50.forEach((e: any, idx) => {
        md += `| ${idx + 1} | @${e.username} | ${e.score.toLocaleString()} | ${e.total_views} | ${e.video_count} | ${e.videos_watched} |\n`;
      });

      setReportMarkdown(md);
      toast({ title: "Report generated!", variant: "wild_green" });
    } catch (err) {
      toast({ title: "Error generating report", variant: "rose_red" });
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const handleLanguageChange = async (newLan: string) => {
    setUserPreferences(prev => ({ ...prev, lan: newLan }));
    
    try {
      await set_user_preferences({
        username: user,
        lan: newLan,
        preferences: userPreferences.preferences.join(',')
      });
      toast({ title: "Language updated", description: "Your preferred language has been saved." });
    } catch (error) {
      toast({ title: "Error", description: "Failed to update language.", variant: "rose_red" });
    }
  };

  const toggleTopic = async (topic: string) => {
    const isSelected = userPreferences.preferences.includes(topic);
    const newPrefsArray = isSelected 
      ? userPreferences.preferences.filter(t => t !== topic)
      : [...userPreferences.preferences, topic];

    // Update local state
    setUserPreferences(prev => ({ ...prev, preferences: newPrefsArray }));

    // Persist immediately to DB
    try {
      await set_user_preferences({
        username: user,
        lan: userPreferences.lan,
        preferences: newPrefsArray.join(',')
      });
      toast({ 
        title: isSelected ? "Topic removed" : "Topic added", 
        description: `"${topic}" preference has been updated.` 
      });
    } catch (error) {
      toast({ title: "Error", description: "Failed to update preference.", variant: "rose_red" });
    }
  };

  const addCustomTag = async () => {
    const tag = customTag.trim().toLowerCase();
    if (tag && !userPreferences.preferences.includes(tag)) {
      const newPrefsArray = [...userPreferences.preferences, tag];
      
      // Update local state first for responsiveness
      setUserPreferences(prev => ({
        ...prev,
        preferences: newPrefsArray
      }));
      setCustomTag('');

      // Persist immediately to DB
      try {
        await set_user_preferences({
          username: user,
          lan: userPreferences.lan,
          preferences: newPrefsArray.join(',')
        });
        toast({ title: "Tag added", description: `"${tag}" is now in your preferences.` });
      } catch (error) {
        toast({ title: "Error", description: "Failed to save tag.", variant: "rose_red" });
      }
    }
  };

  const removeCustomTag = async (tag: string) => {
    const newPrefsArray = userPreferences.preferences.filter(t => t !== tag);
    
    // Update local state
    setUserPreferences(prev => ({
      ...prev,
      preferences: newPrefsArray
    }));

    // Persist immediately to DB
    try {
      await set_user_preferences({
        username: user,
        lan: userPreferences.lan,
        preferences: newPrefsArray.join(',')
      });
      toast({ title: "Tag removed", description: `"${tag}" has been removed.` });
    } catch (error) {
      toast({ title: "Error", description: "Failed to remove tag.", variant: "rose_red" });
    }
  };

  const removeAutoTag = async (tag: string) => {
    try {
      await remove_auto_tag(user, tag);
      // Update local state
      setUserPreferences(prev => {
        const newAuto = { ...prev.auto_preferences };
        delete newAuto[tag];
        return { ...prev, auto_preferences: newAuto };
      });
      toast({ title: "Tag removed", description: `Interest in "${tag}" has been reset.` });
    } catch (error) {
      toast({ title: "Error", description: "Could not remove auto tag.", variant: "rose_red" });
    }
  };

  const handleMuteUser = async () => {
    const muted = newMuteUser.trim().toLowerCase().replace('@', '');
    if (!muted) return;
    if (muted === user) {
      toast({ title: "Wait", description: "You cannot mute yourself.", variant: "rose_red" });
      return;
    }
    const success = await mute_user(user, muted);
    if (success) {
      setMutedUsers(prev => [...new Set([...prev, muted])]);
      setNewMuteUser('');
      toast({ title: "User Muted", description: `@${muted} has been added to your mute list.` });
    } else {
      toast({ title: "Error", description: "Failed to mute user.", variant: "rose_red" });
    }
  };

  const handleUnmuteUser = async (muted: string) => {
    const success = await unmute_user(user, muted);
    if (success) {
      setMutedUsers(prev => prev.filter(u => u !== muted));
      toast({ title: "User Unmuted", description: `@${muted} is no longer muted.` });
    } else {
      toast({ title: "Error", description: "Failed to unmute user.", variant: "rose_red" });
    }
  };

  const handleSavePostingPreferences = async () => {
    try {
      const cleanedBeneficiaries = postingOptions.beneficiaries
        .map(b => ({
          account: b.account.trim().toLowerCase().replace(/@/g, ''),
          weight: b.weight.trim()
        }))
        .filter(b => b.account && b.weight);

      const prefsToSave = {
        rewards: postingOptions.rewards,
        orientation: postingOrientation,
        supportSpeak: postingSupportSpeak,
        beneficiaries: cleanedBeneficiaries
      };

      const res = await set_posting_preferences(user, prefsToSave);
      if (!res.error) {
        toast({
          title: "Posting preferences saved ✅",
          description: "Your default advanced settings have been saved successfully.",
          variant: "wild_green"
        });
      } else {
        toast({
          title: "Error saving preferences",
          description: res.message || "Something went wrong.",
          variant: "rose_red"
        });
      }
    } catch (error: any) {
      toast({
        title: "Error saving preferences",
        description: error.message || "Failed to update posting preferences.",
        variant: "rose_red"
      });
    }
  };

  const handleAuthorizeSteemSeven = async (activeWif = "") => {
    const res = await authorizeAccount(autologin, motherAcc, activeWif);
    if (res.success) {
      setIsAuthorizedSteemSeven(true);
      toast({
        title: "Success",
        description: res.message,
        variant: "wild_green"
      });
    } else {
      if (res.message.toString().includes("Missing Active Authority")) {
        setRequiredActive(true);
        toggleLoginModal();
      } else {
        toast({
          title: "Error",
          description: res.message,
          variant: "rose_red"
        });
      }
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({ title: "Copied to clipboard!", variant: "wild_green" });
  };

  const renderSection = () => {
    let section: React.ReactNode = null;
    if (activeTab === 'app') {
        section = (
          <div className="row mt-1">
            {user && (
              <div className="col-12">
                <div className={`ios-section-header ${expandedSections.storage ? 'active' : ''}`} onClick={() => toggleSection('storage')}>
                  <h3><i className="fas fa-database" /> Storage Usage</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                
                {expandedSections.storage && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Check your uploaded content and plan limits.</p>
                    {ipfsPersonal ? (
                      <div className="mb-3">
                        <p>
                          Plan: <span className={`plan ${planType.includes("plus")?"sun-yellow":"sky-blue"}`}>{planType.replace("-", " ").toUpperCase() || "free"}</span> {((totalPersonalSize ?? 0) / 1e6).toFixed(2)} MB / {Quota} MB
                        </p>
                        {(!planType.includes("plus") && totalStorageSaved > 0) && (
                          <Alert color='primary'>
                            Upgrade to <b>Plus</b> and save up to {((totalStorageSaved ?? 0) / 1e6).toFixed(2)} MB. Delegate at least {MINIMUN_SP_FOR_PLUS} SP to @steem-seven to unlock Plus benefits.
                          </Alert>
                        )} 
                        {ipfsPersonal.length > 0 && (
                          <div className="table-responsive">
                            <table className="table" style={{ textAlign: "left" }}>
                              <thead>
                                <tr>
                                  <td><b>#</b></td>
                                  <td><b>Link</b></td>
                                  <td><b>Size</b></td>
                                  <td><b>Created</b></td>
                                  {user == "alejos7ven" && <td><b>Actions</b></td>}
                                </tr>
                              </thead>
                              <tbody> 
                                  {currentPersonalFiles.map((n, i) => (
                                    <tr key={i}> 
                                      <td className="break-text">{i}</td>
                                      <td className="break-text">
                                        <a
                                          href={r2MediaUrl(n.cid)}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <span className="d-none d-md-inline">{n.cid}</span>
                                          <span className="d-inline d-md-none">{n.cid.substring(0, 12)}...</span>
                                        </a>
                                      </td>
                                      <td className="break-text">{((n.size ?? 0) / 1e6).toFixed(2)} MB</td>
                                      <td className="break-text">{getTimeAgo(n.created_at)}</td>
                                      {user == "alejos7ven" && <td className="break-text">
                                        <button
                                          className="btn btn-sm btn-red"
                                          onClick={() => handleUnpinIpfs(n.cid)}
                                        >
                                          <i className="fas fa-trash"></i> 
                                        </button>
                                      </td>}
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        <div className="pagination-controls text-center mt-3">
                          <Button size="sm" color="secondary" disabled={currentPagePersonal === 1} onClick={() => setCurrentPagePersonal(p => p - 1)}>Previous</Button>
                          <span className="mx-3 small">Page {currentPagePersonal} of {Math.ceil(ipfsPersonal.length / itemsPerPagePersonal)}</span>
                          <Button size="sm" color="secondary" disabled={indexOfLastPersonal >= ipfsPersonal.length} onClick={() => setCurrentPagePersonal(p => p + 1)}>Next</Button>
                        </div> 
                      </div>
                    ) : (
                      <p>Loading...</p>
                    )} 
                  </div>
                )}
              </div>
            )}
            
            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.preferences ? 'active' : ''}`} onClick={() => toggleSection('preferences')}>
                <h3><i className="fas fa-tags" /> Content Preferences</h3>
                <i className="fas fa-chevron-down" />
              </div>
              
              {expandedSections.preferences && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Customize the content you see in your custom feed</p>
                  
                  <div className="settings-section"> 
                    <div className="col-6 settings-info">
                      <label htmlFor="pref-lang">Preferred Language:</label>
                      <p>Select your primary language for video recommendations.</p>
                    </div>
                    <div className="col-6 settings-modifier"> 
                      <select
                        id="pref-lang"
                        className="form-control fancy-input"
                        value={userPreferences.lan}
                        onChange={(e) => handleLanguageChange(e.target.value)}
                      >
                        {PREF_LANGS.map(l => (
                          <option key={l.code} value={l.code}>{l.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                   <div className="settings-section"> 
                    <div className="col-6 settings-info">
                      <label>Favorite Topics:</label>
                      <p>Select pre-defined topics or add your own tags below.</p>
                    </div>
                    <div className="col-6 settings-modifier"> 
                      <div className="pref-grid">
                        {PREF_TOPICS.map(topic => (
                          <div 
                            key={topic} 
                            className={`pref-pill ${userPreferences.preferences.includes(topic) ? 'active' : ''}`}
                            onClick={() => toggleTopic(topic)}
                          >
                            {topic.charAt(0).toUpperCase() + topic.slice(1)}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="settings-section">
                    <div className="col-6 settings-info">
                      <label htmlFor="custom-tag">Custom Tags:</label>
                      <p>Add specific Steem tags to fine-tune your recommendations.</p>
                    </div>
                    <div className="col-6 settings-modifier">
                      <div className="d-flex mb-2">
                        <input 
                          type="text" 
                          id="custom-tag"
                          className="form-control fancy-input mr-2" 
                          placeholder="e.g. photography" 
                          value={customTag}
                          onChange={(e) => setCustomTag(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && addCustomTag()}
                        />
                        <Button color="speem" size="sm" onClick={addCustomTag}><i className="fas fa-plus" /></Button>
                      </div>
                      <div className="pref-grid">
                        {userPreferences.preferences
                          .filter(t => !PREF_TOPICS.includes(t))
                          .map(tag => (
                            <div key={tag} className="pref-pill active custom">
                              {tag}
                              <i className="fas fa-times-circle ml-2" onClick={() => removeCustomTag(tag)} style={{cursor:'pointer'}} />
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                  <div className="settings-section">
                    <div className="col-6 settings-info">
                      <label>Learned Interests:</label>
                      <p>Topics the system has identified from your activity. Click to remove.</p>
                    </div>
                    <div className="col-6 settings-modifier">
                      <div className="pref-grid">
                        {Object.entries(userPreferences.auto_preferences || {}).length > 0 ? (
                          Object.entries(userPreferences.auto_preferences)
                            .sort((a, b) => b[1] - a[1])
                            .map(([tag, count]) => (
                              <div key={tag} className="pref-pill active learned" onClick={() => removeAutoTag(tag)}>
                                {tag} <span className="badge badge-light ml-1" style={{opacity:0.7, fontSize:'0.7rem'}}>{count}</span>
                              </div>
                            ))
                        ) : (
                          <p className="text-muted small italic">No interests learned yet.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.mutes ? 'active' : ''}`} onClick={() => toggleSection('mutes')}>
                <h3><i className="fas fa-user-slash" /> Muted Authors</h3>
                <i className="fas fa-chevron-down" />
              </div>

              {expandedSections.mutes && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Content from these authors will be hidden from your feed.</p>
                  
                  <div className="settings-section">
                    <div className="col-6 settings-info">
                      <label htmlFor="mute-username">Mute Author:</label>
                      <p>Enter the Steem username to hide their content.</p>
                    </div>
                    <div className="col-6 settings-modifier">
                      <div className="d-flex">
                        <input 
                          type="text" 
                          id="mute-username"
                          className="form-control fancy-input mr-2" 
                          placeholder="e.g. authorname" 
                          value={newMuteUser}
                          onChange={(e) => setNewMuteUser(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleMuteUser()}
                        />
                        <Button color="speem" size="sm" onClick={handleMuteUser}><i className="fas fa-plus" /></Button>
                      </div>
                    </div>
                  </div>

                  <div className="settings-section mt-3">
                    <div className="col-12">
                      <label>Your Mute List:</label>
                      <div className="pref-grid mt-2">
                        {mutedUsers.length > 0 ? (
                          mutedUsers.map(muted => (
                            <div key={muted} className="pref-pill active custom">
                              @{muted}
                              <i className="fas fa-times-circle ml-2" onClick={() => handleUnmuteUser(muted)} style={{cursor:'pointer'}} />
                            </div>
                          ))
                        ) : (
                          <p className="text-muted small italic">Your mute list is empty.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.posting_prefs ? 'active' : ''}`} onClick={() => toggleSection('posting_prefs')}>
                <h3><i className="fas fa-paper-plane" /> Posting Preferences</h3>
                <i className="fas fa-chevron-down" />
              </div>

              {expandedSections.posting_prefs && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Set default settings for your new publications.</p>
                  
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input 
                        type="checkbox" 
                        checked={postingSupportSpeak} 
                        onChange={(e) => setPostingSupportSpeak(e.target.checked)} 
                      />{' '}
                      Support Speak on Steem?
                    </Label>
                  </FormGroup>

                  <AdvancedSettings 
                    options={postingOptions} 
                    setOptions={setPostingOptions} 
                    orientation={postingOrientation} 
                    setOrientation={setPostingOrientation} 
                    supportSpeak={postingSupportSpeak} 
                    author={user || ""} 
                    appSettings={app_settings} 
                  />

                  <div className="mt-3 text-right">
                    <Button color="speem" size="sm" onClick={handleSavePostingPreferences}>
                      Save Posting Preferences
                    </Button>
                  </div>
                </div>
              )}
            </div>

            {/* Authority Section */}
            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.authority ? 'active' : ''}`} onClick={() => toggleSection('authority')}>
                <h3><i className="fas fa-key" /> Authority Delegation</h3>
                <i className="fas fa-chevron-down" />
              </div>
              {expandedSections.authority && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Authorize @{motherAcc} to automatically publish your scheduled posts.</p>
                  <div className="p-4 border rounded bg-light-soft mb-3">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <i className="fas fa-info-circle text-speem" />
                        <strong>Current Status:</strong>
                      </div>
                      <div>
                        {isAuthorizedSteemSeven === null ? (
                          <span className="text-muted"><i className="fas fa-spinner fa-spin" /> Checking...</span>
                        ) : isAuthorizedSteemSeven ? (
                          <span className="badge badge-success px-3 py-2">
                            <i className="fas fa-check-circle" /> Authorized to @{motherAcc}
                          </span>
                        ) : (
                          <span className="badge badge-danger px-3 py-2">
                            <i className="fas fa-times-circle" /> Not Authorized to @{motherAcc}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top d-flex justify-content-end gap-3">
                      {isAuthorizedSteemSeven ? (
                        <Button 
                          color="rose_red" 
                          size="sm" 
                          outline
                          onClick={handleRevokeClick}
                          disabled={authorizing}
                        >
                          {authorizing ? <><i className="fas fa-spinner fa-spin" /> Working...</> : <><i className="fas fa-user-minus" /> Revoke Access</>}
                        </Button>
                      ) : (
                        <Button 
                          color="speem" 
                          size="sm" 
                          onClick={handleAuthorizeClick}
                          disabled={authorizing}
                        >
                          {authorizing ? <><i className="fas fa-spinner fa-spin" /> Working...</> : <><i className="fas fa-user-check" /> Authorize Now</>}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Scheduled Posts Section */}
            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.scheduledPosts ? 'active' : ''}`} onClick={() => toggleSection('scheduledPosts')}>
                <h3><i className="fas fa-clock" /> Scheduled Posts</h3>
                <i className="fas fa-chevron-down" />
              </div>
              {expandedSections.scheduledPosts && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Manage your upcoming publications.</p>
                  {scheduledPosts.length === 0 ? (
                    <div className="text-muted text-center py-3">No scheduled posts found.</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th>Date (UTC)</th>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {scheduledPosts.map(post => {
                            let data: any = {};
                            try { data = JSON.parse(post.post_data); } catch(e) {}
                            return (
                              <tr key={post.id}>
                                <td>{new Date(post.scheduled_at).toLocaleString()}</td>
                                <td className="text-truncate" style={{maxWidth: '200px'}}>{data.title || 'No Title'}</td>
                                <td>
                                  <span className={`badge badge-${post.status === 'pending' ? 'warning' : post.status === 'published' ? 'success' : 'danger'}`}>
                                    {post.status}
                                  </span>
                                </td>
                                <td>
                                  {post.status === 'pending' && (
                                    <>
                                      <Button size="sm" color="info" outline className="mr-2" onClick={() => { setPostToEdit(post); setIsEditModalOpen(true); }}>
                                        <i className="fas fa-edit" />
                                      </Button>
                                      <Button size="sm" color="danger" outline onClick={() => handleCancelScheduledPost(post.id)}>
                                        <i className="fas fa-times" />
                                      </Button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.general ? 'active' : ''}`} onClick={() => toggleSection('general')}>
                <h3><i className="fas fa-sliders-h" /> General Settings</h3>
                <i className="fas fa-chevron-down" />
              </div>

              {expandedSections.general && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <div className="settings-section"> 
                    <div className="col-6 settings-info">
                      <label htmlFor="rpcUrl">RPC Node:</label>
                      <p>The RPC node is your link channel to the Steem Blockchain.</p>
                    </div>
                    <div className="col-6 settings-modifier">
                      <input
                        id="rpcUrl"
                        type="text"
                        className="form-control fancy-input"
                        value={rpcUrl}
                        onChange={(e) => setRpcUrl(e.target.value)}
                        placeholder="https://api.steemit.com"
                      />
                    </div>  
                  </div>
                  <div className="settings-section"> 
                    <div className="col-6 settings-info">
                      <label htmlFor="gateway">Playback source:</label>
                      <p>Choose R2 playback or an available IPFS gateway.</p>
                    </div>
                    <div className="col-6 settings-modifier"> 
                      <select
                        id="gateway"
                        className="form-control fancy-input"
                        value={preferredGateway(gateway)}
                        onChange={(e) => setGateway(e.target.value)}
                      >
                        {GATEWAYS.map((g, i) => (
                          <option key={i} value={g}>{gatewayLabel(g)}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="settings-section">
                    <div className="col-6 settings-info">
                      <label htmlFor="autoplay">Auto Play Videos:</label>
                    </div>
                    <div className="col-6 settings-modifier">
                      <label className="custom-checkbox">
                        <input
                          id="autoplay"
                          type="checkbox"
                          checked={autoplay}
                          onChange={(e) => setAutoplay(e.target.checked)}
                        />
                        <span className="checkmark"></span> 
                      </label>
                    </div> 
                  </div> 
                  <div className="col-12 text-right mt-2">
                    <Button color='speem' type='button' onClick={handleSave}>Save Settings</Button>
                  </div>
                </div>
              )}
            </div>


          </div>
        );
    } else if (activeTab === 'profile') {
        section = (
          <div className="row mt-1"> 
            <div className="col-12">
              <div className={`ios-section-header ${expandedSections.profile ? 'active' : ''}`} onClick={() => toggleSection('profile')}>
                <h3><i className="fas fa-user-circle" /> Public Profile Settings</h3>
                <i className="fas fa-chevron-down" />
              </div>
              
              {expandedSections.profile && (
                <div className="ios-section-content animate__animated animate__fadeIn">
                  <p className="ios-section-subtitle">Update the public information for your profile page.</p>
                  <div className="row">
                    <div className="col-md-6">
                      <ImageUploader 
                          inputName="profile_image" 
                          placeholder='Profile image'
                          defaultValue={newProfile.profile_image}
                          register={register}
                          setErrorMessage={(err)=> toast({title:"OPs something failed",description:err, variant:"rose_red"})}
                          onUpload={(url) => {
                            setNewProfile({ ...newProfile, profile_image: url })
                          }}
                          watch={watch}
                          setValue={setValue}
                      />
                    </div> 
                    <div className="col-md-6">
                      <ImageUploader 
                          inputName="cover_image" 
                          placeholder='Cover image'
                          defaultValue={newProfile.cover_image}
                          register={register}
                          setErrorMessage={(err)=> toast({title:"OPs something failed",description:err, variant:"rose_red"})}
                          onUpload={(url) => {
                            setNewProfile({ ...newProfile, cover_image: url })
                          }}
                          watch={watch}
                          setValue={setValue}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control fancy-input mb-3 mt-3"
                        value={newProfile.name}
                        onChange={(e) => setNewProfile({ ...newProfile, name: e.target.value })}
                        placeholder="Public Name"
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control fancy-input mb-3"
                        value={newProfile.location}
                        onChange={(e) => setNewProfile({ ...newProfile, location: e.target.value })}
                        placeholder="Location"
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control fancy-input mb-3"
                        value={newProfile.website}
                        onChange={(e) => setNewProfile({ ...newProfile, website: e.target.value })}
                        placeholder="Website"
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control fancy-input mb-3"
                        value={newProfile.about}
                        onChange={(e) => setNewProfile({ ...newProfile, about: e.target.value })}
                        placeholder="About"
                      />
                    </div>
                    <div className="col-md-6 ">
                      <Button color="speem" onClick={()=>{handleAccountUpdate();}}>
                        Save Profile
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
    } else if (activeTab === 'admin') {
        section = (
          <div className="row animate__animated animate__fadeIn mt-1">
              {/* AdSense Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.adsense ? 'active' : ''}`} onClick={() => toggleSection('adsense')}>
                  <h3><i className="fas fa-ad" /> Google AdSense</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.adsense && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Toggle target-wide advertisements across the platform.</p>
                    <div className="card shadow-none border p-3" style={{ background: 'rgba(var(--speem-color-rgb), 0.05)', borderRadius: '12px' }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <b>Ads Enabled</b>
                          <p className="mb-0 text-muted small">When disabled, no AdSense units will render.</p>
                        </div>
                        <div className="custom-control custom-switch">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="adsToggle" 
                            checked={auth.site_settings?.ads_enabled === 'true'}
                            onChange={handleToggleAds}
                          />
                          <label className="custom-control-label" htmlFor="adsToggle" style={{ cursor: 'pointer' }}>
                            {auth.site_settings?.ads_enabled === 'true' ? 'Active' : 'Off'}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* IPFS Status Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.ipfs ? 'active' : ''}`} onClick={() => toggleSection('ipfs')}>
                  <h3><i className="fas fa-server" /> Video Storage</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.ipfs && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="small">{((totalSize || 0) / 1e6).toFixed(2) || 0.00} MB / 1000 GB</span>
                      <div style={{maxWidth:"240px", width:"100%"}}>
                        <input
                          type="text"
                          className="form-control form-control-sm fancy-input"
                          placeholder="Search user..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Total Size</th>
                            <th>Files</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentAdminUsers.map((u, i) => (
                            <tr
                              key={i}
                              className={selectedUser === u.user ? "active-row" : ""}
                              style={{ cursor: "pointer" }}
                              onClick={() => setSelectedUser(selectedUser === u.user ? null : u.user)}
                            >
                              <td>{u.user} {u.plan?.includes("plus") && <VerifiedIcon size={14} className="color-speem ml-1" />}</td>
                              <td>{(u.total_size).toFixed(2)} MB</td>
                              <td>{u.files.length}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="pagination-controls text-center mt-2">
                      <Button size="sm" color="secondary" disabled={currentPageAdminUsers === 1} onClick={() => setCurrentPageAdminUsers(p => p - 1)}>Prev</Button>
                      <span className="mx-2 small">Page {currentPageAdminUsers} of {Math.ceil(filteredAdminUsers.length / itemsPerPageAdminUsers) || 1}</span>
                      <Button size="sm" color="secondary" disabled={indexOfLastAdminUsers >= filteredAdminUsers.length} onClick={() => setCurrentPageAdminUsers(p => p + 1)}>Next</Button>
                    </div>
                    
                    {selectedUser && (() => {
                      const selectedUserPlanType = selectedUserData?.plan || "free";
                      const selectedUserQuota = selectedUserData?.quota || 5000;
                      const selectedUserFiles = selectedUserData?.files || [];
                      
                      // Archivos que cuentan según la regla
                      const selectedUserValidFiles = selectedUserFiles.filter(item => 
                        selectedUserPlanType.includes("plus") ? Number(item.days_ago) <= DAYS_FOR_RESET : true
                      );

                      // Archivos que quedarían fuera (ahorro)
                      const selectedUserRemovedFiles = selectedUserFiles.filter(item => 
                        Number(item.days_ago) > DAYS_FOR_RESET
                      );

                      // Total usado actualmente con reglas
                      const selectedUserTotalSize = selectedUserValidFiles.reduce(
                        (acc, item) => acc + (parseFloat(item.size) || 0), 
                        0
                      );

                      // Total potencial a ahorrar
                      const selectedUserTotalStorageSaved = selectedUserRemovedFiles.reduce(
                        (acc, item) => acc + (parseFloat(item.size) || 0), 
                        0
                      );

                      return (
                        <div className="mt-3 p-3 border rounded bg-light shadow-sm animate__animated animate__fadeIn">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Support Panel - Storage for: <b>@{selectedUser}</b></h5>
                            <Button size="sm" color="link" onClick={() => setSelectedUser(null)}>Close</Button>
                          </div>

                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <p className="mb-0">
                                Plan: <span className={`plan ${selectedUserPlanType.includes("plus") ? "sun-yellow" : "sky-blue"}`}>{selectedUserPlanType.replace("-", " ").toUpperCase() || "free"}</span> {((selectedUserTotalSize ?? 0) / 1e6).toFixed(2)} MB / {selectedUserQuota} MB
                              </p>
                              {selectedUserData?.status === 'manual' ? (
                                <button className="btn btn-xs btn-red" onClick={() => handleDemotePlus(selectedUser)}>
                                  <i className="fas fa-user-minus mr-1" /> Remove Manual Plus
                                </button>
                              ) : (
                                <button className="btn btn-xs btn-green" onClick={() => handlePromotePlus(selectedUser)}>
                                  <i className="fas fa-user-plus mr-1" /> Promote to Plus (Manual)
                                </button>
                              )}
                            </div>
                            {(!selectedUserPlanType.includes("plus") && selectedUserTotalStorageSaved > 0) && (
                              <Alert color='primary' className="mb-3">
                                Upgrade to <b>Plus</b> and save up to {((selectedUserTotalStorageSaved ?? 0) / 1e6).toFixed(2)} MB. Delegate at least {MINIMUN_SP_FOR_PLUS} SP to @steem-seven to unlock Plus benefits.
                              </Alert>
                            )}
                          </div>

                          <div className="table-responsive">
                            <table className="table table-sm" style={{ fontSize: '0.85rem', textAlign: 'left' }}>
                              <thead>
                                <tr>
                                  <td><b>#</b></td>
                                  <td><b>Link</b></td>
                                  <td><b>Size</b></td>
                                  <td><b>Created</b></td>
                                  <td><b>Actions</b></td>
                                </tr>
                              </thead>
                              <tbody>
                                {currentSelectedUserFiles.map((f, i) => (
                                  <tr key={i}>
                                    <td className="break-text">{indexOfFirstSelectedUser + i}</td>
                                    <td className="break-text">
                                      <a
                                        href={r2MediaUrl(f.cid)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <span className="d-none d-md-inline">{f.cid}</span>
                                        <span className="d-inline d-md-none">{f.cid.substring(0, 12)}...</span>
                                      </a>
                                    </td>
                                    <td className="break-text">{(f.size / 1e6).toFixed(2)} MB</td>
                                    <td className="break-text">{getTimeAgo(f.created_at)}</td>
                                    <td className="break-text">
                                      <button
                                        className="btn btn-xs btn-red"
                                        onClick={() => handleUnpinIpfs(f.cid)}
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          <div className="pagination-controls text-center mt-3">
                            <Button size="sm" color="secondary" disabled={currentPageSelectedUser === 1} onClick={() => setCurrentPageSelectedUser(p => p - 1)}>Previous</Button>
                            <span className="mx-3 small">Page {currentPageSelectedUser} of {Math.ceil(selectedUserFiles.length / itemsPerPageSelectedUser) || 1}</span>
                            <Button size="sm" color="secondary" disabled={indexOfLastSelectedUser >= selectedUserFiles.length} onClick={() => setCurrentPageSelectedUser(p => p + 1)}>Next</Button>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>

              {/* Notifications Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.notifications ? 'active' : ''}`} onClick={() => toggleSection('notifications')}>
                  <h3><i className="fas fa-bullhorn" /> Global Notifications</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.notifications && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Push new alerts to all users.</p>
                    <div className="row g-2 mb-3">
                      <div className="col-md-5"> 
                        <input type="text" className="form-control form-control-sm fancy-input" value={newNotification.url} onChange={(e) => setNewNotification({ ...newNotification, url: e.target.value })} placeholder="URL link" />
                      </div>
                      <div className="col-md-5"> 
                        <input type="text" className="form-control form-control-sm fancy-input" value={newNotification.msg} onChange={(e) => setNewNotification({ ...newNotification, msg: e.target.value })} placeholder="Message" />
                      </div>
                      <div className="col-md-2">
                        <Button size="sm" color="default" block onClick={handleCreateNotification}>Add</Button>
                      </div>
                    </div>
                    {adminNotifications.length > 0 && (
                      <div className="table-responsive">
                        <table className="table table-sm">
                          <tbody>
                            {adminNotifications.map((n, i) => (
                              <tr key={i}>
                                <td className='small'>{n.msg}</td>
                                <td><span className={`badge ${n.active ? "badge-success" : "badge-danger"}`}>{n.active ? "Active" : "Off"}</span></td>
                                <td className="text-right">
                                  <button className="btn btn-xs btn-outline-info mr-1" onClick={() => handleToggleStatus(n)}><i className={`fas ${n.active ? "fa-eye-slash" : "fa-eye"}`}></i></button>
                                  <button className="btn btn-xs btn-outline-danger" onClick={() => handleDeleteNotification(n.id)}><i className="fas fa-trash"></i></button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>


              {/* Blacklist Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.blacklist ? 'active' : ''}`} onClick={() => toggleSection('blacklist')}>
                  <h3><i className="fas fa-user-slash" /> Ranking Blacklist</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.blacklist && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Exclude users from the Weekly Leaderboard.</p>
                    <div className="row g-2 mb-3">
                      <div className="col-md-4">
                        <input type="text" className="form-control form-control-sm fancy-input" placeholder="Username" value={newBlacklistEntry.username} onChange={e => setNewBlacklistEntry({ ...newBlacklistEntry, username: e.target.value })} />
                      </div>
                      <div className="col-md-6">
                        <input type="text" className="form-control form-control-sm fancy-input" placeholder="Reason" value={newBlacklistEntry.reason} onChange={e => setNewBlacklistEntry({ ...newBlacklistEntry, reason: e.target.value })} />
                      </div>
                      <div className="col-md-2">
                        <Button size="sm" color="default" block onClick={handleAddBlacklist}>Add</Button>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <tbody>
                          {blacklist.map((entry, i) => (
                            <tr key={i}>
                              <td><b>@{entry.username}</b></td>
                              <td className="small">{entry.reason || '-'}</td>
                              <td className="text-right"><button className="btn btn-xs btn-red" onClick={() => handleRemoveBlacklist(entry.username)}><i className="fas fa-user-minus"></i></button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>

              {/* Carousel Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.carousel ? 'active' : ''}`} onClick={() => toggleSection('carousel')}>
                  <h3><i className="fas fa-images" /> Carousel Banners</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.carousel && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Manage home page banners.</p>
                    <div className="row g-2 mb-3">
                      <div className="col-md-5">
                        <ImageUploader inputName="banner_src" placeholder='Image URL' register={register} setErrorMessage={(err)=>toast({title:"Error", description:err, variant:"rose_red"})} onUpload={(url)=>setNewBanner({...newBanner, src:url})} watch={watch} setValue={setValue} />
                      </div>
                      <div className="col-md-5">
                        <input type="text" className="form-control form-control-sm fancy-input" placeholder="Link" value={newBanner.link} onChange={(e)=>setNewBanner({...newBanner, link:e.target.value})} />
                      </div>
                      <div className="col-md-2">
                        <Button size="sm" color="default" block onClick={handleCreateBanner}>Add</Button>
                      </div>
                    </div>
                    <div className="row">
                      {carouselItems.map((item, i) => (
                        <div key={i} className="col-md-4 mb-2">
                          <div className="position-relative border rounded overflow-hidden">
                            <img src={item.src} className="img-fluid" alt="banner" style={{height: 60, objectFit:'cover', width:'100%'}} />
                            <button className="btn btn-xs btn-red position-absolute" style={{top:2, right:2}} onClick={()=>handleDeleteBanner(item.id)}><i className="fas fa-times" /></button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Reports Section */}
              <div className="col-12 mb-3">
                <div className={`ios-section-header ${expandedSections.reports ? 'active' : ''}`} onClick={() => toggleSection('reports')}>
                  <h3><i className="fas fa-file-invoice" /> Leaderboard Reports</h3>
                  <i className="fas fa-chevron-down" />
                </div>
                {expandedSections.reports && (
                  <div className="ios-section-content animate__animated animate__fadeIn">
                    <p className="ios-section-subtitle">Generate Markdown reports for community posts.</p>
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <Button size="sm" color="secondary" onClick={() => setReportWeekOffset(w => w - 1)}><i className="fas fa-chevron-left" /></Button>
                      <div className="mx-3 font-weight-bold small">{formatWeekLabel(getWeekStart(reportWeekOffset))}</div>
                      <Button size="sm" color="secondary" disabled={reportWeekOffset === 0} onClick={() => setReportWeekOffset(w => w + 1)}><i className="fas fa-chevron-right" /></Button>
                      <Button size="sm" color="speem" className="ml-4" disabled={isGeneratingReport} onClick={generateLeaderboardReport}>{isGeneratingReport ? <i className="fas fa-spinner fa-spin" /> : "Generate"}</Button>
                    </div>
                    {reportMarkdown && (
                      <div className="mt-2">
                        <textarea className="form-control fancy-input small" style={{height:150, fontFamily:'monospace'}} readOnly value={reportMarkdown} />
                        <Button size="sm" color="default" block className="mt-1" onClick={() => copyToClipboard(reportMarkdown)}>Copy Markdown</Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
          </div>
        );
    } else {
      return <div className="text-center">Ops, something went wrong.</div>;
    }
    return section;
  }

  useEffect(() => {
    setRpcUrl(rpc_node || 'https://api.steemit.com'); 
    setAutoplay(app_settings.autoplay || false);
    setGateway(preferredGateway(app_settings?.gateway)); 
  }, [rpc_node, app_settings]); 

  useEffect(() => {
    if (activeTab === 'admin') {
      (async () => {
        try {
          const notifications = await get_db_notifications(true);
          const carousel = await get_carousel_items();
          const ipfs = await get_ipfs_usage(); 
          
          setAdminNotifications(notifications);
          setCarouselItems(carousel);
          console.log(ipfs);
          // setFiles(ipfs.files);
          setGroupedUsers(groupByUser(ipfs.files));
          
          setIpfsAccount(ipfs); 
          
        } catch (error) {
          console.log(error);
          toast({
            title: "Unexpected error",
            description: error,
            variant:"rose_red"
          }); 
        }
      })();
    }else if (activeTab == "app") {
      (async () => { 
        const mAccount = await fetchScheduleAccount();
        setMotherAcc(mAccount);

        try {
          const authStatus = await isAuthorized(user, mAccount);
          setIsAuthorizedSteemSeven(authStatus);
        } catch (e) {
          setIsAuthorizedSteemSeven(false);
        }

        const ipfs = await get_ipfs_usage(user); 
        setPlanType(ipfs.plan || "free")
        setIpfsPersonal(ipfs.files || []);
        if (isAdmin) {
          handleFetchBlacklist();
        }
        
        let prefs: any = null;
        try {
          prefs = await get_user_preferences(user);
          const mutes = await get_muted_users(user);
          setMutedUsers(mutes);
        } catch (e) {
          // Silent
        }

        if (prefs && prefs.length > 0) {
          const prefsData = prefs[0];
          setUserPreferences({
            lan: prefsData.lan || 'en',
            preferences: prefsData.preferences ? prefsData.preferences.split(',').map((t: string) => t.trim()) : [],
            auto_preferences: prefsData.auto_preferences ? JSON.parse(prefsData.auto_preferences) : {}
          });
          if (prefsData.posting_preferences) {
            try {
              const parsed = JSON.parse(prefsData.posting_preferences);
              setPostingOptions({
                rewards: parsed.rewards || '1',
                beneficiaries: parsed.beneficiaries || [{ account: '', weight: '' }]
              });
              setPostingOrientation(parsed.orientation || 'clip');
              setPostingSupportSpeak(parsed.supportSpeak !== undefined ? parsed.supportSpeak : true);
            } catch (e) {
              console.error("Failed to parse posting preferences", e);
            }
          }
        }
        
        // Fetch scheduled posts
        fetchScheduledPosts();
      })();
    }
  }, [activeTab, isAdmin]);
  useEffect(() => { 
    (async () => {
      try {
        const perm = await is_admin(user); 
        const quota = await get_quota(user); 
        setIsAdmin(perm.isAdmin);
        setQuota(quota.quota);
      } catch (error) {
        console.log(error);
        toast({
            title: "Unexpected error",
            description: error,
            variant:"rose_red"
          }); 
      }
    })(); 
  }, []);

  const handleSave = () => {
    updateRPCNode(rpcUrl);
    if (typeof setSteemConfig === 'function') {
      setSteemConfig(rpcUrl);
    }
    updateAppSettings({...app_settings,autoplay:autoplay, editor:app_settings.editor || "", gateway:preferredGateway(gateway)}); 
    toast({
        title: "Settings saved ✅",
        description: `Refresh the page to see the changes.`,
        variant:"wild_green"
      }); 
  };

  return (
    <>
      <div className="user-settings mt-2 container-fluid"> 
      <div className="col-12 mb-3">
        <h2>Settings</h2>
      </div>
      <div className="ios-settings-wrapper shadow-sm mx-3 mb-5">
        <div className="ios-sidebar">
          <div 
            className={`ios-menu-item ${activeTab === 'app' ? 'active' : ''}`} 
            onClick={() => navigate('/settings/app')}
          >
            <div><i className="fas fa-cog menu-icon" /> App & Preferences</div>
            <i className="fas fa-chevron-right" />
          </div>
          <div 
            className={`ios-menu-item ${activeTab === 'profile' ? 'active' : ''}`} 
            onClick={() => navigate('/settings/profile')}
          >
            <div><i className="fas fa-user-circle menu-icon" /> Profile</div>
            <i className="fas fa-chevron-right" />
          </div>
          {isAdmin && (
            <div 
              className={`ios-menu-item ${activeTab === 'admin' ? 'active' : ''}`} 
              onClick={() => navigate('/settings/admin')}
            >
              <div><i className="fas fa-user-shield menu-icon" /> Administrator</div>
              <i className="fas fa-chevron-right" />
            </div>
          )}
        </div>
        <div className="ios-content-panel">
          {renderSection()}
        </div>
      </div>
      <AppModal 
        isShowing={showRevokeModal} 
        hide={() => setShowRevokeModal(false)} 
        size="md" 
        header="Revoke Authority"
      >
        <div className="p-4 text-center">
          <div className="mb-4">
            <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '3.5rem' }} />
          </div>
          <h4 className="mb-3">Are you sure?</h4>
          <p className="text-muted mb-4">
            You are about to revoke posting authority from <strong>@{motherAcc}</strong>. 
            You won't be able to schedule posts until you authorize again.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <Button color="secondary" outline onClick={() => setShowRevokeModal(false)}>
              Cancel
            </Button>
            <Button color="rose_red" onClick={confirmRevoke}>
              Yes, Revoke
            </Button>
          </div>
        </div>
      </AppModal>

      <LoginModal
        isShowing={isOpenLoginModal}
        hide={toggleLoginModal}
        requiredActive={requiredActive}
        onSuccess={(res: any) => {
          if (res && res.wif) {
            if (activeTab === 'app' && expandedSections.authority) {
              if (revokingAuthority) {
                handleRevokeSteemSeven(res.wif);
              } else {
                handleAuthorizeSteemSeven(res.wif);
              }
            } else {
              handleAccountUpdate(res.wif);
            }
          }
          setRevokingAuthority(false);
          setRequiredActive(false);
        }}
      />

      {isEditModalOpen && (
        <ContentCreatePostModal
          isShowing={isEditModalOpen}
          hide={() => setIsEditModalOpen(false)}
          postToEdit={postToEdit}
          onSuccess={() => fetchScheduledPosts()}
        />
      )}
    </div>
    </>
  );
};

export default UserSettings;
